import React from 'react';
import { connect } from 'react-redux';

import Notifications from 'react-notification-system-redux';

export function Notification(props) {
  return (
    <Notifications
      notifications={props.notifications}
    />
  );
}

export const mapStateToProps = state => ({
  notifications: state.notifications,
});

export default connect(
  mapStateToProps,
)(Notification);
